import * as React from "react";
import { useBloomreachSiteLogos } from "@grandvisionhq/bloomreach";
import { useProductData, PromoteInstallments } from "@grandvisionhq/fun-products";
import { useFeatureToggles } from "@grandvisionhq/state";
const PromoteInstallmentsGraphContainer = ({ textAlign, opcoConfiguration }) => {
  const { isPdpPromoteInstallmentsEnabled } = useFeatureToggles();
  const siteLogos = useBloomreachSiteLogos();
  const { product } = useProductData();
  if (!isPdpPromoteInstallmentsEnabled) return null;
  return /* @__PURE__ */ React.createElement(
    PromoteInstallments,
    {
      siteLogos,
      numberOfInstallments: opcoConfiguration.numberOfInstallments,
      minimumPrice: opcoConfiguration.minimumPrice,
      productType: product.productType,
      textAlign
    }
  );
};
export {
  PromoteInstallmentsGraphContainer
};
//# sourceMappingURL=PromoteInstallmentsGraphContainer.js.map
